import script from "./DasChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./DasChart.vue?vue&type=script&lang=ts&setup=true"

import "./DasChart.vue?vue&type=style&index=0&id=384e33b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384e33b6"]])

export default __exports__